import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export default function useNavigateToCompany(): (id: number) => void {
    const navigate = useNavigate();

    return useCallback((id: number) => {
        navigate(`/companies/${id}`);
    }, []);
}